import { Business } from "./business.type";

export type OrderType = "d" | "s" | "demo" | "test";

export const OrderTypeLabel = {
  "d": "Directus",
  "s": "Shopify",
  "demo": "Demo",
  "test": "Test"
}

export type Order = {
  id: string;
  status: string;
  city_escape: string;
  default_language: string;
  frontend_url?: string;
  type: OrderType;
  business?: Business;
};

export type ShopifyOrderOutput = {
  id: string;
  shopify_order: string;
  status: string;
  account: string;
  email: string;
  variant: string;
  purchased_at: string;
  city_escape: string;
};


